import * as React from 'react';
import cx from 'classnames';

import './checkbox.styles.scss';

export type CheckboxProps = React.PropsWithChildren<{
  className?: string;
  label?: React.ReactNode;
  onChange?: (checked: boolean, params: { value: string | number; e: React.ChangeEvent<HTMLInputElement> }) => void; 
}> & Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'onChange'>;

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { label: labelContent, className, onChange, children, ...otherProps } = props;

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.checked, { value: e.target.value, e });
    }
  }, [onChange]);
  
  return (
    <div className={cx('checkbox Checkbox', className)}>
      <label>
        <input 
          {...otherProps}
          type="checkbox"
          onChange={handleChange}
        />
        {labelContent || children}
      </label>
    </div>
  );
};

